<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <div class="lg:max-w-detaillg lg:mr-auto">

          <div class="mb-2">
            <label for="switch-calendario-activo" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
              {{$t('clients.calendario_festivos_activo')}}
              <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
            </label>
            <el-switch 
              id="switch-calendario-activo"
              :aria-label="$t('clients.calendario_festivos_activo')"
              class="switch-text break-normal both-switch mt-2" 
              v-model="form.activo" 
              :active-text="$t('companies.active')"/>
          </div>

          <localization language="es-ES">
            <intl locale="es">

              <div class="flex p-1 items-center justify-center mr-4">
                <div class="flex p-1 items-center justify-center">
                  <base-button-icon 
                    v-if="isMoreLowerYear" 
                    @click="modifyYear(false)" 
                    title="Año anterior"
                    ariaLabel="Cambiar al año anterior"
                    name="chevronleft" 
                    size="xs" 
                    mode="primary-phantom" 
                    :disabled="!totalDaysSelected || totalDaysSelected.length > 0"
                    />
                  <div v-else class="w-8"></div>
                  <div class="pl-2 pr-2 dark:text-darkblue-200">Año {{form.year}}</div>
                  <base-button-icon 
                    v-if="(actualYear + 1) > form.year" 
                    @click="modifyYear(true)" 
                    title="Año siguiente"
                    ariaLabel="Cambiar al año siguiente"
                    name="chevronright" 
                    size="xs"
                    mode="primary-phantom" 
                    :disabled="!totalDaysSelected || totalDaysSelected.length > 0"
                    />
                  <div v-else class="w-8"></div>
                </div>
              </div>

              <div class="lg:mb-4 w-full flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('holidays_calendar.recurrent_days') + ': '" />
                  <div class=" ml-2 h-5 w-5 bg-primary-800 border border-solid border-darkblue-600 rounded-full"/>
                </div>
                <div class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('holidays_calendar.occasional_days') + ': '" />
                  <div class=" ml-2 h-5 w-5 bg-secondary-600 border border-solid border-darkblue-600 "/>
                </div>
              </div>

              <div class="vld-parent">
                <loading :opacity="darkMode ? 0 : 0.5" :active="loadingCalendar" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
                <div v-if="!loadingCalendar"  class="flex flex-wrap">
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Enero</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar1"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month1"
                      :navigation="false"
                      :value="form.datesMonth1"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 0, 1)"
                      :max="new Date(form.year, 0, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar1"
                            :title="isSpecialDate(props.value, 1)"
                            :mark="isMarked(props.value, 1)"
                            :markRecurrent="isMarkedRecurrent(props.value, 1)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Febrero</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar2"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month2"
                      :navigation="false"
                      :value="form.datesMonth2"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 1, 1)"
                      :max="new Date(form.year, 1, esBisiestoActual ? 29 : 28)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar2"
                            :title="isSpecialDate(props.value, 2)"
                            :mark="isMarked(props.value, 2)"
                            :markRecurrent="isMarkedRecurrent(props.value, 2)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Marzo</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar3"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month3"
                      :navigation="false"
                      :value="form.datesMonth3"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 2, 1)"
                      :max="new Date(form.year, 2, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar3"
                            :title="isSpecialDate(props.value, 3)"
                            :mark="isMarked(props.value, 3)"
                            :markRecurrent="isMarkedRecurrent(props.value, 3)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Abril</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar4"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month4"
                      :navigation="false"
                      :value="form.datesMonth4"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 3, 1)"
                      :max="new Date(form.year, 3, 30)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar4"
                            :title="isSpecialDate(props.value, 4)"
                            :mark="isMarked(props.value, 4)"
                            :markRecurrent="isMarkedRecurrent(props.value, 4)"
                           />
                        </template>
                    </calendar>
                  </div>
                
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Mayo</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar5"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month5"
                      :navigation="false"
                      :value="form.datesMonth5"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 4, 1)"
                      :max="new Date(form.year, 4, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar5"
                            :title="isSpecialDate(props.value, 5)"
                            :mark="isMarked(props.value, 5)"
                            :markRecurrent="isMarkedRecurrent(props.value, 5)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Junio</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar6"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month6"
                      :navigation="false"
                      :value="form.datesMonth6"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 5, 1)"
                      :max="new Date(form.year, 5, 30)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar6"
                            :title="isSpecialDate(props.value, 6)"
                            :mark="isMarked(props.value, 6)"
                            :markRecurrent="isMarkedRecurrent(props.value, 6)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Julio</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar7"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month7"
                      :navigation="false"
                      :value="form.datesMonth7"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 6, 1)"
                      :max="new Date(form.year, 6, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar7"
                            :title="isSpecialDate(props.value, 7)"
                            :mark="isMarked(props.value, 7)"
                            :markRecurrent="isMarkedRecurrent(props.value, 7)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Agosto</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar8"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month8"
                      :navigation="false"
                      :value="form.datesMonth8"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 7, 1)"
                      :max="new Date(form.year, 7, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar8"
                            :title="isSpecialDate(props.value, 8)"
                            :mark="isMarked(props.value, 8)"
                            :markRecurrent="isMarkedRecurrent(props.value, 8)"
                           />
                        </template>
                    </calendar>
                  </div>
                
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Septiembre</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar9"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month9"
                      :navigation="false"
                      :value="form.datesMonth9"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 8, 1)"
                      :max="new Date(form.year, 8, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar9"
                            :title="isSpecialDate(props.value, 9)"
                            :mark="isMarked(props.value, 9)"
                            :markRecurrent="isMarkedRecurrent(props.value, 9)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Octubre</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar10"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month10"
                      :navigation="false"
                      :value="form.datesMonth10"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 9, 1)"
                      :max="new Date(form.year, 9, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar10"
                            :title="isSpecialDate(props.value, 10)"
                            :mark="isMarked(props.value, 10)"
                            :markRecurrent="isMarkedRecurrent(props.value, 10)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Noviembre</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar11"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month11"
                      :navigation="false"
                      :value="form.datesMonth11"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 10, 1)"
                      :max="new Date(form.year, 10, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar11"
                            :title="isSpecialDate(props.value, 11)"
                            :mark="isMarked(props.value, 11)"
                            :markRecurrent="isMarkedRecurrent(props.value, 11)"
                           />
                        </template>
                    </calendar>
                  </div>
                  <div class="p-1">
                    <div class="dark:text-darkblue-200">Diciembre</div>
                    <calendar
                      :disabled="disableActionsVacaciones"
                      ref="calendar12"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month12"
                      :navigation="false"
                      :value="form.datesMonth12"
                      :cell="'myTemplate'"
                      :min="new Date(form.year, 11, 1)"
                      :max="new Date(form.year, 11, 31)"
                      @keydown.native="handleCalendarKeydown"
                      >
                        <template v-slot:myTemplate="{ props }">
                          <Customcell 
                            :data-item="props.dataItem"
                            :is-weekend="props.isWeekend"
                            :is-focused="props.isFocused"
                            :is-selected="props.isSelected"
                            :value="props.value"
                            :formatted-value="props.formattedValue"
                            @click="onChangeCalendar12"
                            :title="isSpecialDate(props.value, 12)"
                            :mark="isMarked(props.value, 12)"
                            :markRecurrent="isMarkedRecurrent(props.value, 12)"
                           />
                        </template>
                    </calendar>
                  </div>
                </div>
                <div v-else class="w-full h-[774px]"/>
              </div>
          </intl>
        </localization>
        </div>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <!-- <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('configurations.change_mode_template_edit')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/> -->
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_clients')" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <!-- <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_clients')" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          /> -->
          <base-button-responsive 
            v-if="isAllDaySelectedUnmarked"
            mode="primary" 
            :text="$t('clients.calendario_festivos_send')" 
            icon="export" 
            @click="togglesendDays()" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
          <base-button-responsive 
            v-if="isAllDaySelectedMarked"
            mode="primary" 
            :text="$t('clients.calendario_festivos_delete')" 
            icon="trash" 
            @click="deleteDaysHandler()" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
            >
            <p>Se han preseleccionado</p>
            <p>los clientes seleccionados. </p>
          </el-popover>
        </template>
      </base-footer>
      <input-text-switch-dialog 
        :dialogOpen="showModal" 
        @toggleDialog="togglesendDays" 
        @applyDialog="sendDaysHandler"
        header="Añadir día festivo" 
        headerValue="Nombre del día festivo" 
        switchHeaderValue="Tipo de día festivo"
        switchHeaderValueActive="Recurrente"
        switchHeaderValueInactive="Puntual"
        />
      <template-link-clients-dialog 
        ref="templatelinkcompaniesdialog" 
        :title="titleLinkClients" 
        :distributorId="this.id" 
        :dialogOpen="linkToClientsDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import Loading from 'vue-loading-overlay'

import Customcell from '@/components/kendo/calendar/CustomCell.vue'
import InputTextSwitchDialog from '@/components/InputTextSwitchDialog.vue'

import { getDistributor } from '@/services/distributors/getDistributor'
import { getHolidayCalendarTemplate } from '@/services/distributors/getHolidayCalendarTemplate'
import { addHolidayCalendarTemplate } from '@/services/clients/addHolidayCalendarTemplate'
import { updateHolidayCalendarTemplate } from '@/services/distributors/updateHolidayCalendarTemplate'
import { deleteDaysHolidayCalendarTemplate } from '@/services/clients/deleteDaysHolidayCalendarTemplate'
import { applyHolidayCalendarTemplate } from '@/services/distributors/applyHolidayCalendarTemplate'
import TemplateLinkClientsDialog from '@/components/TemplateLinkClientsDialog.vue'

import { i18n } from '@/i18n'
import { Calendar } from '@progress/kendo-vue-dateinputs'
import { IntlProvider, LocalizationProvider } from '@progress/kendo-vue-intl'

export default {
  /* eslint-disable camelcase */
  name: 'holiday-calendar-template-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkClientsDialog,
    calendar: Calendar,
    localization: LocalizationProvider,
    intl: IntlProvider,
    Loading,
    Customcell,
    InputTextSwitchDialog,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      enableEditCampos: true,
      searchView: false,
      linkToClientsDialog: false,
      activeName: 'es',
      header: {
        title: i18n.t('clients.calendario_festivos_header_template'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/distributors/details' : 'configurations/clients'
      },
      festivos: [],
      showModal: false,
      loadingCalendar: false,
      actualYear: new Date().getFullYear(),
      focusedDates: {
        month1: new Date(new Date().getFullYear(), 0, 1),
        month2: new Date(new Date().getFullYear(), 1, 1),
        month3: new Date(new Date().getFullYear(), 2, 1),
        month4: new Date(new Date().getFullYear(), 3, 1),
        month5: new Date(new Date().getFullYear(), 4, 1),
        month6: new Date(new Date().getFullYear(), 5, 1),
        month7: new Date(new Date().getFullYear(), 6, 1),
        month8: new Date(new Date().getFullYear(), 7, 1),
        month9: new Date(new Date().getFullYear(), 8, 1),
        month10: new Date(new Date().getFullYear(), 9, 1),
        month11: new Date(new Date().getFullYear(), 10, 1),
        month12: new Date(new Date().getFullYear(), 11, 1),
      },
      // checkall: false,
      // valuesCheckbox: {
      //   StoredSpace: false,
      //   NumSMS: false,
      //   NumLocations: false,
      //   NumCompanies: false,
      //   NumeroSedesxCIFEmpresas: false,
      //   NumUsers: false,
      //   daysGroupsCompanies: false,
      //   mailsGroupCompanies: false,
      //   mailsTo: false,
      //   VincularUsuariosGrupoGestorNEOs: false,
      //   mesesUserPass: false,
      // },
      form: {
        activo: false,
        year: 1999,
        datesMonth1: [],
        datesMonth2: [],
        datesMonth3: [],
        datesMonth4: [],
        datesMonth5: [],
        datesMonth6: [],
        datesMonth7: [],
        datesMonth8: [],
        datesMonth9: [],
        datesMonth10: [],
        datesMonth11: [],
        datesMonth12: [],
      },
      rules: {
      }
    }
  },
  computed: {
    esBisiestoActual () {
      return (this.form?.year % 4 === 0 && this.form?.year % 100 !== 0) || (this.form?.year % 400 === 0)
    },
    disableActionsVacaciones () {
      return this.isLowerThanActualYear
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkClients () {
      return this.modeTemplate ? 'Aplicar plantilla a clientes' : 'Aplicar campos seleccionados a clientes'
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    totalDaysSelected () {
      const fechas = this.form.datesMonth1
        .concat(this.form.datesMonth2)
        .concat(this.form.datesMonth3)
        .concat(this.form.datesMonth4)
        .concat(this.form.datesMonth5)
        .concat(this.form.datesMonth6)
        .concat(this.form.datesMonth7)
        .concat(this.form.datesMonth8)
        .concat(this.form.datesMonth9)
        .concat(this.form.datesMonth10)
        .concat(this.form.datesMonth11)
        .concat(this.form.datesMonth12)
      return fechas.map(x => this.formatToUTC(x))
    },
    isAnyDaySelected () {
      return this.totalDaysSelected.length > 0
    },
    isAllDaySelectedMarked () {
      if (this.isAnyDaySelected) {
        // Obtenemos ambas listas de fechas mapeadas
        const soloDiasMesSelected = this.selectedDayMonth
        const fechasFestivos = this.getFestivosMap()

        // console.log(soloDiasMesSelected)
        // console.log(fechasFestivos)

        // Si todas coinciden => todas estan marcadas
        const res = soloDiasMesSelected?.every(x => fechasFestivos.some(y => y === x))
        return res
      }
      return false
    },
    isAllDaySelectedUnmarked () {
      if (this.isAnyDaySelected) {
        // Obtenemos ambas listas de fechas mapeadas
        const soloDiasMesSelected = this.selectedDayMonth
        const fechasFestivos = this.getFestivosMap()

        // console.log(soloDiasMesSelected)
        // console.log(fechasFestivos)

        // Si existe alguna coincidencia => NO estan todos los días sin marcar
        const res = fechasFestivos?.some(x => soloDiasMesSelected.some(y => y === x))
        return !res
      }
      return false
    },
    // Devuelve objeto mapeado de fechas seleccionadas actualmente
    selectedDayMonth () {
      if (this.isAnyDaySelected) return this.totalDaysSelected?.map(fecha => this.mapDateToObjMonthDay(fecha)).sort()
      return []
    },
    isYearActual () {
      return this.actualYear === this.form.year
    },
    isLowerThanActualYear () {
      return this.form.year < this.actualYear
    },
    isMoreLowerYear () {
      if (this.form.year > this.actualYear) return true
      return this.festivos.filter(x => x.anyo < this.form.year).length > 0
    },
    isFromClient () {
      return this.id !== -1
    }
  },
  watch: {
    'form.year': function (value, oldValue) {
      this.onChangeYear(value)
    },
    'form.activo': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = this.$i18n.t('configurations.template_header_text_mode')
      else this.header.title = this.$i18n.t('configurations.template_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []

    if (this.isFromClient) {
      breadcrumbs.push({
        path: 'configurationssa',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/distributors',
        name: this.$i18n.t('distributors.header')
      })
      const distributor = await this.downloadDistributorData(this.id)
      breadcrumbs.push({ path: '', name: distributor.distribuidor.Nombre })
      this.$store.commit('app/setheaderBreadCrumb', distributor.distribuidor.Nombre)
      this.disableRoutes(distributor.distribuidor.idTipoProvisionamiento)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectClients()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template)
    }
    this.resetControlFormChanges()
  },
  methods: {
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    togglesendDays () {
      this.showModal = !this.showModal
    },
    getFestivosMap () {
      return this.festivos
        ?.filter(x => x.anyo === this.form.year || x.recurrent)
        .map(x => this.mapDateToObjMonthDay(x.fecha))
    },
    // Mapea a un objeto mes / dia
    mapDateToObjMonthDay (date) {
      return new Date(date).toLocaleDateString('en-ES', { month: 'numeric', day: 'numeric' })
    },
    isMarkedRecurrent (cellValue, month) {
      let elements = this.getElementsFestivos(cellValue, month)
      elements = elements.filter(x => x.recurrent)
      return (elements && elements.length > 0)
    },
    isMarked (cellValue, month) {
      let elements = this.getElementsFestivos(cellValue, month)
      elements = elements.filter(x => !x.recurrent)
      return (elements && elements.length > 0)
    },
    isSpecialDate (cellValue, month) {
      const elements = this.getElementsFestivos(cellValue, month)
      if (elements && elements.length > 0) {
        return elements[0].nombre
      }
      return 'Sin festivo'
    },
    getElementsFestivos (cellValue, month) {
      return this.festivos?.filter(
        (x) => x.day === cellValue.getDate() && x.month === month && (x.recurrent === true || x.anyo === this.form.year)
      )
    },
    formatToUTC (date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
    },
    onChangeCalendar1 (value) { 
      const actualValue = this.form.datesMonth1
      this.form.datesMonth1 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar2 (value) { 
      const actualValue = this.form.datesMonth2
      this.form.datesMonth2 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar3 (value) { 
      const actualValue = this.form.datesMonth3
      this.form.datesMonth3 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar4 (value) { 
      const actualValue = this.form.datesMonth4
      this.form.datesMonth4 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar5 (value) { 
      const actualValue = this.form.datesMonth5
      this.form.datesMonth5 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar6 (value) { 
      const actualValue = this.form.datesMonth6
      this.form.datesMonth6 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar7 (value) { 
      const actualValue = this.form.datesMonth7
      this.form.datesMonth7 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar8 (value) { 
      const actualValue = this.form.datesMonth8
      this.form.datesMonth8 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar9 (value) { 
      const actualValue = this.form.datesMonth9
      this.form.datesMonth9 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar10 (value) { 
      const actualValue = this.form.datesMonth10
      this.form.datesMonth10 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar11 (value) { 
      const actualValue = this.form.datesMonth11
      this.form.datesMonth11 = this.commonOnChangeCalendar(value, actualValue)
    },
    onChangeCalendar12 (value) { 
      const actualValue = this.form.datesMonth12
      this.form.datesMonth12 = this.commonOnChangeCalendar(value, actualValue)
    },
    commonOnChangeCalendar (value, actualValue) {
      // Obtenemos la fecha seleccionada en Array
      let resArray
      if (!Array.isArray(value)) {
        resArray = [value]
      }
      
      // Si no tiene valor actual, establecemmos el seleccionado
      if (!actualValue || actualValue.length === 0) {
        actualValue = resArray
      } else {
        // Si tiene valor y contiene el seleccionado, eliminamos
        if (actualValue
          .map(x => x.getDate())
          .includes(resArray[0].getDate())) {
          actualValue = actualValue.filter(x => x.getDate() !== resArray[0].getDate())
        // Si tiene valor y no contiene el seleccionado, añadimos
        } else {
          actualValue.push(resArray[0])
        }
      }
      return actualValue
    },
    modifyYear (add) {
      if (add) this.form.year = this.form.year + 1
      else this.form.year = this.form.year - 1
      if (!this.existYear(this.form.year)) this.modifyYear(add)
    },
    existYear (year) {
      if (this.actualYear === year || this.actualYear + 1 === year) return true
      if (this.festivos.filter(x => x.anyo === this.form.year).length > 0) return true
      return false
    },
    onChangeYear (newYear) {
      this.cleanValuesMonths()
      this.loadingCalendar = true
      this.focusedDates.month1.setFullYear(newYear)
      this.focusedDates.month2.setFullYear(newYear)
      this.focusedDates.month3.setFullYear(newYear)
      this.focusedDates.month4.setFullYear(newYear)
      this.focusedDates.month5.setFullYear(newYear)
      this.focusedDates.month6.setFullYear(newYear)
      this.focusedDates.month7.setFullYear(newYear)
      this.focusedDates.month8.setFullYear(newYear)
      this.focusedDates.month9.setFullYear(newYear)
      this.focusedDates.month10.setFullYear(newYear)
      this.focusedDates.month11.setFullYear(newYear)
      this.focusedDates.month12.setFullYear(newYear)
      setTimeout(() => {
        this.loadingCalendar = false
      }, 100)
    },
    cleanValuesMonths () {
      this.form.datesMonth1 = []
      this.form.datesMonth2 = []
      this.form.datesMonth3 = []
      this.form.datesMonth4 = []
      this.form.datesMonth5 = []
      this.form.datesMonth6 = []
      this.form.datesMonth7 = []
      this.form.datesMonth8 = []
      this.form.datesMonth9 = []
      this.form.datesMonth10 = []
      this.form.datesMonth11 = []
      this.form.datesMonth12 = []
    },
    disableRoutes: function (idTipoProvisionamiento) {
      const objDisableRoutes = {
        disableModules: idTipoProvisionamiento === 1,
        disableLocations: idTipoProvisionamiento === 1,
      }
      bus.$emit('disableOptionsDistributor', objDisableRoutes)
    },
    preSelectClients () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.clients) {
        this.$refs.templatelinkcompaniesdialog.changeSelectedCompanies(data.clients)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      // this.valuesCheckbox.StoredSpace = value 
      // this.valuesCheckbox.NumSMS = value 
      // this.valuesCheckbox.NumLocations = value 
      // this.valuesCheckbox.NumCompanies = value
      // this.valuesCheckbox.NumeroSedesxCIFEmpresas = value
      // this.valuesCheckbox.NumUsers = value
      // this.valuesCheckbox.daysGroupsCompanies = value
      // this.valuesCheckbox.mailsGroupCompanies = value
      // this.valuesCheckbox.mailsTo = value
      // this.valuesCheckbox.VincularUsuariosGrupoGestorNEOs = value
      // this.valuesCheckbox.mesesUserPass = value
    },
    toggleDialogLink: function () {
      this.linkToClientsDialog = !this.linkToClientsDialog
      if (this.linkToClientsDialog) {
        this.doFeedback('Se aplicará el año actual y el año siguiente a los clientes seleccionados', 'info')
      }
    },
    applyLinkHandler: async function (clients) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateClients('ruleForm', clients)
      }
      //  else {
      //   this.UpdateClientsWithSelected('ruleForm', clients)
      // }
    },
    downloadDistributorData: async function (id) {
      let distributor = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idDistribuidor: id
        }
        distributor = await getDistributor(params)
        if (distributor.blnError === true) {
          this.doFeedback(distributor.msgError + ' [Código de error: ' + distributor.codError + ']')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return distributor
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    sendDaysHandler: async function (form) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idDistribuidor: this.id,
          Nombre: form.value,
          Recurrente: form.switch,
          Year: this.form.year,
          Fechas: [],
        }
        this.totalDaysSelected.forEach(x => {
          const aux = {
            Month: (x.getMonth() + 1),
            Day: x.getDate(),
          }
          payload.Fechas.push(aux)
        })

        const response = await addHolidayCalendarTemplate(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Datos actualizados correctamente', 'success')
          this.togglesendDays()
          const data = await this.downloadData(this.id)
          const auxFormYear = this.form.year
          this.setTemplate(data)
          setTimeout(() => {
            if (auxFormYear === this.actualYear) this.onChangeYear(auxFormYear)
            else this.form.year = auxFormYear
          }, 300)
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteDaysHandler: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idDistribuidor: this.id,
          Year: this.form.year,
          Fechas: [],
        }
        this.totalDaysSelected.forEach(x => {
          const aux = {
            Month: (x.getMonth() + 1),
            Day: x.getDate(),
          }
          payload.Fechas.push(aux)
        })

        const response = await deleteDaysHolidayCalendarTemplate(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Datos actualizados correctamente', 'success')
          const data = await this.downloadData(this.id)
          const auxFormYear = this.form.year
          this.setTemplate(data)
          setTimeout(() => {
            if (auxFormYear === this.actualYear) this.onChangeYear(auxFormYear)
            else this.form.year = auxFormYear
          }, 300)
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    submitForm: async function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          Activo: this.form.activo,
          idDistribuidor: this.id,
        }          
        const response = await updateHolidayCalendarTemplate(null, payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Plantilla guardada correctamente', 'success')
          this.resetControlFormChanges()
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    submitFormAndUpdateClients: async function (formName, clients) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          Activo: this.form.activo,
          idDistribuidor: this.id,
        }  
        this.toggleDialogLink()
        const response = await updateHolidayCalendarTemplate(null, payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Plantilla guardada correctamente', 'success')
          this.resetControlFormChanges()
          const response = await applyHolidayCalendarTemplate({ idDistribuidor: this.id }, clients)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Clientes actualizados correctamente', 'success')
            this.resetControlFormChanges()
          }
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    // UpdateClientsWithSelected: function (formName, clients) {
    //   this.$store.commit('setAjaxRequestPending', true)
    //   this.$store.commit('setIsLoading', true)
    //   this.$refs[formName].validate(async valid => {
    //     if (valid) {
    //       const params = {
    //         idDistribuidor: this.id,
    //         idClientes: clients,

    //         checkNumeroSedes: this.disableTipoLibre ? null : this.valuesCheckbox.NumLocations,
    //         checkNumeroCIFEmpresas: this.disableTipoLibre ? null : this.valuesCheckbox.NumCompanies,
    //         checkNumeroUsuarios: this.disableTipoLibre ? null : this.valuesCheckbox.NumUsers,
    //         checkEspacioTotal: this.disableTipoLibre ? null : this.valuesCheckbox.StoredSpace,
    //         checkNumeroSedesxCIFEmpresas: this.disableTipoLibre ? null : this.valuesCheckbox.NumeroSedesxCIFEmpresas,
    //         checkNumeroSMS: this.disableTipoLibre ? null : this.valuesCheckbox.NumSMS,
    //         checkEnviarMailCopiaOculta: this.valuesCheckbox.mailsTo,
    //         checkEnviarMailGruposNoPropietarios: this.valuesCheckbox.mailsGroupCompanies,
    //         checkGestionarDiasAvisosGrupos: this.valuesCheckbox.daysGroupsCompanies,
    //         checkVincularUsuariosGrupoGestorNEOs: this.valuesCheckbox.VincularUsuariosGrupoGestorNEOs,
    //         checkMesesUserPass: this.valuesCheckbox.mesesUserPass,

    //         NumeroSedes: this.disableTipoLibre ? null :this.form.NumLocations,
    //         NumeroCIFEmpresas: this.disableTipoLibre ? null :this.form.NumCompanies,
    //         NumeroUsuarios: this.disableTipoLibre ? null :this.form.NumUsers,
    //         EspacioTotal: this.disableTipoLibre ? null :this.form.StoredSpace,
    //         NumeroSedesxCIFEmpresas: this.disableTipoLibre ? null :this.form.NumeroSedesxCIFEmpresas,
    //         NumeroSMS: this.disableTipoLibre ? null :this.form.NumSMS,
    //         EnviarMailCopiaOculta: this.form.mailsTo,
    //         EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
    //         GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
    //         VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
    //         MesesUserPass: this.form.mesesUserPass,
    //       }
    //       this.toggleDialogLink()
    //       const response = await applyClientKeys({ idDistribuidor: this.id }, params)
    //       if (response.blnError === true) {
    //         this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
    //       } else {
    //         this.doFeedback('Clientes actualizados correctamente', 'success')
    //       }
    //     } else {
    //       this.doFeedback('Error al procesar los datos, revise la información')
    //     }
    //     this.$store.commit('setIsLoading', false)
    //   })
    // },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/distributors/details', params: this.id })
      else this.$router.push({ name: 'configurations/clients' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getHolidayCalendarTemplate({ idDistribuidor: this.id })
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        } else {
          return template
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (data) {
      if (data) {
        if (data.Fechas) {
          this.festivos = data.Fechas.map(x => {
            return {
              anyo: x.Year,
              day: x.Day,
              month: x.Month,
              nombre: x.Nombre,
              recurrent: x.Recurrente,
              fecha: new Date(x.Year, (x.Month -1), x.Day),
            } 
          })
        }
        this.form.activo = data.Activo
      }
      this.form.year = new Date().getFullYear()
      this.resetControlFormChanges()
    },
  }

}
</script>
